import {getBasePath} from '@miro-site/shared-utils-templates'

export default getBasePath
